
//======================================================================================
// 28Th Oct, 2025 src/components/tenantcomponents/LegalAgreements/AcceptableUsePolicy.js
//======================================================================================
import React from 'react';
import { Typography, Box } from '@mui/material';

const AcceptableUsePolicy = () => (
  <Box sx={{ maxHeight: '300px', overflow: 'auto', p: 2, border: '1px solid #ccc' }}>
    <Typography variant="h6" gutterBottom>
      ACCEPTABLE USE POLICY
    </Typography>
    
    <Typography variant="body2" paragraph>
      <strong>PROHIBITED ACTIVITIES:</strong>
    </Typography>
    
    <Typography variant="body2" component="div">
      <ul>
        <li>Sharing login credentials with unauthorized users</li>
        <li>Attempting to reverse engineer or modify the software</li>
        <li>Using the system for illegal pharmaceutical activities</li>
        <li>Bypassing prescription validation systems</li>
        <li>Data scraping or automated data extraction</li>
        <li>Simultaneous logins from multiple locations without authorization</li>
        <li>Storing false or misleading medication information</li>
        <li>Using the system to distribute malware or spam</li>
        <li>Engaging in activities that violate applicable laws or regulations</li>
        <li>Using the system to infringe on intellectual property rights</li>
        <li>Excessive use of system resources that impacts performance for other users</li>
        <li>Using the system to facilitate fraudulent transactions or insurance claims</li>
        <li>- Using the system during a known outage or data inconsistency without reporting it to MedicERP</li>
        <li>- Relying solely on MedicERP for regulatory record-keeping without 
          independent verification</li>
      </ul>
    </Typography>
    <Typography variant="body2" paragraph>
      <strong>COMPLIANCE REQUIREMENTS:</strong><br/>
      - Maintain accurate inventory records as per drug control regulations<br/>
      - Prescription drugs must follow proper documentation<br/>
      - GST compliance for all transactions<br/>
      - Regular data backup verification<br/>
    </Typography>
  </Box>
);
export default AcceptableUsePolicy;